import React from 'react'
import { Link } from 'react-router-dom'

import { conditionalLink } from '../../conditional-link'
import { Pill } from '@myxplor/ui'

const IssCaseRecord = ({ record, path, selected = false }) => (
  <div className="listItemContent">
    <div>
      {conditionalLink(
        !selected,
        <Link to={path}>
          <div className="listItemContent--heading">{record.gov_id}</div>

          <dl className="listItemContent--details">
            <li>
              <dt title="Start Date">Start Date</dt>
              <dd>{record.gov_record.StartDate}</dd>
            </li>
            <li>
              <dt title="End Date">End Date</dt>
              <dd>{record.gov_record.EndDate}</dd>
            </li>
          </dl>
        </Link>
      )}
    </div>
    <div className="listItemContent--indicators">
      <Pill key={record.gov_record.Status}>{record.gov_record.Status}</Pill>
    </div>
  </div>
)

export default IssCaseRecord



// WEBPACK FOOTER //
// ./src/iss-cases/views/index.jsx